export * from './session'

export const rePhoneNumber = /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/;

export function getUser(obj: { phone: string }) {
  return obj.phone.replace(/\D/g,'')
}